export type AnalyticsValue = string | number | boolean;
export type AnalyticsProperties = Record<string, AnalyticsValue>;

declare global {
  interface Window {
    umami?: {
      track(event: string, properties?: AnalyticsProperties): void;
    };
  }
}

export function track(event: string, properties: AnalyticsProperties = {}): void {
  window.umami?.track(event, properties);
}

export function analyticsActionForRequest(path: string, method: string): {
  event: string;
  properties?: AnalyticsProperties;
} | null {
  const verb = method.toUpperCase();

  if (verb === "POST" && /^\/v1\/auth\/(apple|google)$/.test(path)) {
    return { event: "sign_in_completed", properties: { provider: path.endsWith("apple") ? "apple" : "google" } };
  }
  if (verb === "POST" && path === "/v1/auth/sign-out") return { event: "sign_out_completed" };
  if (verb === "PUT" && path.startsWith("/v1/me/library/titles/")) return { event: "library_title_added" };
  if (verb === "PATCH" && /^\/v1\/me\/library\/[^/]+$/.test(path)) return { event: "library_item_updated" };
  if (verb === "DELETE" && /^\/v1\/me\/library\/[^/]+$/.test(path)) return { event: "library_title_removed" };
  if (verb === "POST" && path === "/v1/import/mydramalist") return { event: "mydramalist_import_submitted" };
  if (verb === "POST" && path === "/v1/me/lists") return { event: "list_created" };
  if (verb === "PATCH" && path.startsWith("/v1/me/lists/")) return { event: "list_updated" };
  if (verb === "DELETE" && /^\/v1\/me\/lists\/[^/]+$/.test(path)) return { event: "list_deleted" };
  if (verb === "POST" && /\/items$/.test(path)) return { event: "list_item_added" };
  if (verb === "DELETE" && path.includes("/items/")) return { event: "list_item_removed" };
  if (verb === "PUT" && /\/follow$/.test(path)) return { event: "public_list_followed" };
  if (verb === "DELETE" && /\/follow$/.test(path)) return { event: "public_list_unfollowed" };
  if (verb === "POST" && /\/friend-request$/.test(path)) return { event: "friend_request_sent" };
  if (verb === "POST" && /\/friend-requests\/[^/]+\/accept$/.test(path)) return { event: "friend_request_accepted" };
  if (verb === "POST" && /\/friend-requests\/[^/]+\/decline$/.test(path)) return { event: "friend_request_declined" };
  if (verb === "PUT" && path.startsWith("/v1/blocks/")) return { event: "user_blocked" };
  if (verb === "DELETE" && path.startsWith("/v1/blocks/")) return { event: "user_unblocked" };
  if (verb === "POST" && path === "/v1/reports") return { event: "safety_report_submitted" };
  if (verb === "PATCH" && path === "/v1/me") return { event: "profile_updated" };
  if (verb === "DELETE" && path === "/v1/me") return { event: "account_deleted" };
  return null;
}
